import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/Logo';
import { PropsWithoutRef } from 'react';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }: PropsWithoutRef<{ open: boolean }>) => {
    const theme = useTheme();

    return (
        // only available in paid version
        <DrawerHeaderStyled theme={theme} open={open}>
            <Stack position="relative" direction="row" spacing={1} alignItems="center">
                <Logo open={open} />
            </Stack>
        </DrawerHeaderStyled>
    );
};

DrawerHeader.propTypes = {
    open: PropTypes.bool,
};

export default DrawerHeader;
